/**
 * HenniPenny mark + wordmark lockup. The mark is the brand logo — a bespectacled
 * chicken who models the sky rather than panicking about it — served as a crisp
 * round emblem (public/logo.png), matching the landing (hennipenny.com). The
 * wordmark is "Henni" + an amber "Penny", the landing's signature treatment.
 */
import { BRAND_NAME } from './brand';

export function HenniPennyMark({ size = 34 }: { size?: number }) {
  return (
    <img
      src="/logo.png"
      alt="HenniPenny emblem — a bespectacled chicken calmly modeling the sky"
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        objectFit: 'cover',
        borderRadius: '50%',
        background: '#f4efe7',
        border: '2px solid rgba(244, 239, 231, 0.25)',
        flexShrink: 0,
        display: 'block',
      }}
    />
  );
}

/** Mark + wordmark lockup. "Henni" in the surface ink, "Penny" in the amber accent. */
export function HenniPennyLockup({
  size = 34,
  wordSize = 21,
  color = 'var(--theme-text)',
  accent = 'var(--theme-accent)',
}: {
  size?: number;
  wordSize?: number;
  color?: string;
  accent?: string;
}) {
  const [head, tail] = splitBrandName(BRAND_NAME);
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
      <HenniPennyMark size={size} />
      <span
        style={{
          fontFamily: 'var(--theme-font-display)',
          fontSize: wordSize,
          fontWeight: 800,
          letterSpacing: '-0.02em',
          color,
        }}
      >
        {head}
        <span style={{ color: accent }}>{tail}</span>
      </span>
    </span>
  );
}

/** "HenniPenny" -> ["Henni", "Penny"] so the second half can take the accent. */
function splitBrandName(name: string): [string, string] {
  const mid = Math.ceil(name.length / 2);
  return [name.slice(0, mid), name.slice(mid)];
}
